import dynamic from "next/dynamic";

// // // //

export { SolanaWalletProvider } from "./components/SolanaWalletProvider";

/**
 * AssetSwapCta
 * Client-only inline order card (wallet adapters require `window`). The
 * loading placeholder mirrors the card's shape so there's no layout shift.
 */
export const AssetSwapCta = dynamic(() => import("./components/AssetSwapCta"), {
    ssr: false,
    loading: () => (
        <div className="w-full animate-pulse rounded-lg border bg-card p-4">
            <div className="mb-6 h-5 w-32 rounded bg-muted" />
            <div className="mb-3 h-9 w-full rounded bg-muted/60" />
            <div className="mb-3 h-9 w-full rounded bg-muted/60" />
            <div className="mb-6 h-9 w-full rounded bg-muted/60" />
            <div className="h-11 w-full rounded-full bg-muted" />
        </div>
    ),
});

/**
 * NavbarWallet
 * Client-only navbar chip for the connected wallet (address + disconnect).
 * Renders nothing while loading or when no wallet is connected.
 */
export const NavbarWallet = dynamic(() => import("./components/NavbarWallet"), {
    ssr: false,
    loading: () => null,
});
